import Vue from 'vue'
import axios from 'axios'
import Pusher from 'pusher-js'
import moment from 'moment-timezone'
import router from './router'

Pusher.Runtime.createXHR = function () {
  let xhr = new XMLHttpRequest()
  xhr.withCredentials = true
  return xhr
}

let pathname = window.location.pathname
let subDomain = window.location.host.split('.')[0]
let center = subDomain
if (pathname !== '/') center += '_' + pathname.replace('/', '')
Storage.prototype._setItem = Storage.prototype.setItem
Storage.prototype.setItem = function (key, value) {
  key = center + '.' + key
  localStorage._setItem(key, value)
}
Storage.prototype._getItem = Storage.prototype.getItem
Storage.prototype.getItem = function (key) {
  key = center + '.' + key
  return localStorage._getItem(key)
}

Storage.prototype._clear = Storage.prototype.clear
Storage.prototype.clear = function () {
  let keys = Object.keys(localStorage)
  for (let i in keys) {
    let key = keys[i]
    let arr = key.split('.')
    let clear = false
    if (arr[1] !== undefined) {
      if (arr[0] === center) clear = true
    } else {
      if (center === '') clear = true
    }
    if (clear) localStorage.removeItem(key)
  }
}

function interceptors (http) {
  http.defaults.validateStatus = function (status) {
    return status >= 200 && status < 405
  }
  http.interceptors.response.use(function (response) {
    // if (response.data.status === false) return Promise.reject(new Error('Session Gone'))
    if (response.status === 401) {
      let lang = localStorage.getItem('lang')
      localStorage.clear()
      localStorage.setItem('lang', lang)
      router.push('/login')
      return Promise.reject(new Error('401 error'))
    }
    if (response.status === 403) return Promise.reject(new Error('403 error'))
    return response
  }, function (error) {
    return Promise.reject(error.message)
  })
}
let self = Vue.prototype
Object.defineProperty(self, '$http', {
  get () {
    let http = axios.create({baseURL: process.env.END_POINT, withCredentials: true})
    interceptors(http)
    return http
  }
})

Object.defineProperty(self, '$moment', {
  get () {
    return moment
  },
  set (tz) {
    moment.tz.setDefault(tz)
  }
})

Object.defineProperty(self, '$pusher', {
  get () {
    if (self.pusher !== undefined) return self.pusher
    console.log('INITIATING PUSHER COMMUNICATION')
    return (self.pusher = new Pusher(Vue.PUSHER_KEY, {cluster: 'ap2', encrypted: true}))
  }
})

Object.defineProperty(self, '$channel', {
  get () {
    if (self.channel !== undefined) return self.channel
    console.log('INITIATING CHANNEL')
    return (self.channel = self.$pusher.subscribe(localStorage.getItem('school_id')))
  }
})

const Session = {}
export default Session



// WEBPACK FOOTER //
// ./src/session.js